import authorizedAPIInstance from '@/api/authorizedAPI';
export const getFirstFeatureData = async (
  params?: any
): Promise<any> => {
  const { data } = await authorizedAPIInstance.get<any>(
    '/first-feature',
    {
      params,
    }
  );
  return data;
};